module.exports = __webpack_public_path__ + "static/assets/31b1516ffc1b43f7b6c03258c9cd977f.png";